import React , { useState , useEffect}from 'react'


// Documentacion en https://docs.sheetjs.com/docs

import * as XLSX from 'xlsx'

import  {ApiCallPost}  from '../ApiCall/ApiCall'

import Search from './Search'

import SearchUnidad from './SearchUnidad'

import Header from './Header'

import ShowTheExcel from './ShowTheExcel'


import ProductoInput from '../Productos/ProductoInput'
//import CatViewer from '../Catalogos/CatViewer'
//import CatForm from '../Catalogos/CaatForm'

import FormCatalogo from '../Catalogos/FormCatalogo'
import LoadCodigoAgrupador from './LoadCodigoAgrupador'
import FormCatConfig from '../Catalogos/FormCatConfig'
import DoCaseParse from '../DoCase/DoCaseParse'


export default function LoadExcel() {

  const [data,setData] = useState([]) // Aqui se cargan los datos de excel
  const [hojaName,setHojaName] = useState("")
  const [fieldName,setFieldName] = useState("") // =>>>>>>
   //const [shName,setShName] = useState("")
   const [showExcel,setShowExcel] = useState( false )
   const [producto,setProducto] = useState( false ) 
   const [clavePod,setClaveProd] = useState( "") ;
   const [claveUnidad,setClaveUnidad] = useState( "" ) ;
   const [theSearch,setTheSearch] = useState( false )
   const [unidad,setUnidad] = useState( false ) ;
   const [unidadData,setUnidadData ] = useState( [])
   const [prodText,setProdText] = useState( "") ;
   const [myUnidad,setMyUnidad] = useState( "") ;
   const [showCatalogo,setShowCatalogo] = useState( false ) ;
   const [loadCodigo,setLoadCodigo] = useState( false )
   const [showCatConfig,setShowCatConfig] = useState( false )
   const [showDoCase,setShowDoCase] = useState( false )




   function setTheShowDoCase()
   {
        setShowDoCase( true ) ;
   }

   function closeDoCase()
   {
        setShowDoCase( false ) ;
   }

   function closeCatConfig()
   {
    setShowCatConfig( false ) ;
   }

   function setTheShowCatConfig()
   {

    console.log( "setTheSowCatConfig") ;

    setProducto( false ) ;
    setShowExcel(false)
    setShowCatalogo( false ) ;
    setLoadCodigo( false )
    setShowCatConfig( true )


   }


   function onClose()
   {

        
    console.log( "onClose") ;
    setProducto( false ) ;
    setShowExcel(false)
    setShowCatalogo( false ) ;
    setLoadCodigo( false )
    setShowCatConfig( false )
    setShowDoCase( false ) ;
   }


   function setTheLoadCodigo()
   {
        setProducto( false ) ;
        setShowExcel(false)
        setShowCatalogo( false ) ;
        setShowCatConfig( false  )
        setLoadCodigo( true )
   }

   function onCloseCatalogo()
   {
     setShowCatalogo( false ) ;
   }

   function setTheCatalogo()
   {
    //setTheSearch( false )
    //setUnidad( false )    
    

    setLoadCodigo( false )
    setProducto( false ) ;
    setShowExcel(false)
    setShowCatConfig( false  )
    setShowCatalogo( true ) ;
   }

   function setTheProdText( value )
   {
    console.log( "setTheProdText = " + value ) ;
    setProdText( value ) ;
   }

   function setTheSearch2(val)
   {
    console.log( "setTheSearch2 " + val ) ;

    setTheSearch( true )
    setUnidad( false )    
   }

   function showTheUnidad( val )
   {
    console.log( "showUnidad") ;
    setUnidad( true )
    setTheSearch( false ) 

   }

   function setClave( value )
   {
    console.log( "Otro value = " + value )

    setClaveProd( value ) ;
   }

   function setTheUnidad( value )
   {
        //setUnidadData( value ) ;
        setTheSearch( false ) 
        setUnidad( true )
        
   }


   //function setC

   function showMyExcel( )
   {
        setLoadCodigo( false )
        setProducto( false ) ;
        setShowCatalogo( false ) 
        setShowCatConfig( false  );
        setShowExcel(!showExcel)
   }


   function showProducto()
   {
        setLoadCodigo( false )
        setShowExcel(false ) ;
        setShowCatalogo( false ) ;
        setShowCatConfig( false  )
        setProducto(!producto)
   }


   function showHome()
   {
        setLoadCodigo( false )
        setShowExcel(false ) ;
        setProducto( false )
        setShowCatalogo( false ) ;
        setShowCatConfig( false  )
   }


  const handleUpload = (e) => {

    console.log( "handleUpload")

    const reader = new FileReader() ; 
    reader.readAsBinaryString(e.target.files[0])

    reader.onload = async (e) => {
        const data2 = e.target.result ;
        const workbook = XLSX.read( data2 ,{ type : "binary"  , cellDates: true , cellNF: true}) // 
        //const workbook = XLSX.readFile( data ,{cellDates: true , type : "binary"})
        //const sheetName = workbook.SheetNames[0] ;

        //setShName( sheetName );

        console.log( "Lista de pestañas")   
        for( var i = 0 ; i <  workbook.SheetNames.length ; i++  )
        {
            console.log( workbook.SheetNames[i])
        }
        

        //const sheet = workbook.Sheets[sheetName] ;
        
        //const sheet = workbook.Sheets['c_Aduana'] ; // c_Pais

        var theField = ""

        if ( fieldName!== "") // =>>>>>
        {
            // Usamos el nombre el campo
            theField = fieldName ;
            console.log( "Usamos fieldName")
        }else {
            theField = hojaName ;
            console.log( "Usamos hojaName " + theField )
        }

        console.log( "HojaName = " + hojaName )

        const sheet = workbook.Sheets[hojaName] ; // c_Pais

        const parseData = XLSX.utils.sheet_to_json( sheet , { header : 1 })


        var newParse = [] ;


        var isFound = false ;


        console.log( "Length = " +  parseData.length)

        for ( var row = 0 ; row <  parseData.length ; row ++)
        {
            // if ( row < 9 )
            // {
            //     console.log( "row:" + row + " " + parseData[row]) ;
            // }
            
            console.log( "row = " + row )

            if ( row < 9  && typeof parseData[row][0] === "string" )
            {
                console.log( "row:" + row + " " + parseData[row][0].toUpperCase()) ;
                console.log( "hojaName = " + theField.toUpperCase())
            }
            

            if ( typeof parseData[row][0] === "string")
            {
                if ( parseData[row][0].toUpperCase() === theField.toUpperCase() 
                    /*sheetName */)
                {
                    isFound = true ;
                }
            }



            if ( isFound )
            {
                newParse.push( parseData[row] ) ;
            }

        }


 
        console.log( "Saliendo de " + theField + " isFound = " + isFound )

        await ApiCallPost( hojaName , newParse ) // 

        console.log( "Despues del ApiCall") ;

        setData( newParse ) ;



        console.log( "Despues de parseData " + newParse.length )
        

        //console.log( data) ;

    }
  }

  function handleTheChange( value )
  {
    console.log( "en loadexcel = " + value )

    setHojaName( value )
  }


  function handleField( e )
  {
    console.log( e.target.value )

    setFieldName( e.target.value )
  }


  

  function getFormatDate(d) {
    var date = new Date(d);
    var dateStr =
        date.getFullYear() + "-" +
        ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
        ("00" + date.getDate()).slice(-2) + " " ;
    	
    //console.log(dateStr);

    return dateStr;
}



  function addDays(date, days) {

    console.log( date ) 

    var result = new Date(date);
    result.setDate(result.getDate() + days -1);
    return result.toString() ;
  }

  return (
    <div className='w-100' >


        <Header showProducto={showProducto} showMyExcel={showMyExcel} 
            showHome={showHome}  showCatalogo={setTheCatalogo} 
            loadCodigo={setTheLoadCodigo} 
            showCatConfig={setTheShowCatConfig} clear={onClose}
            theShowDoCase={setTheShowDoCase}></Header>


        {
            loadCodigo && (
                <LoadCodigoAgrupador close={onClose}></LoadCodigoAgrupador>
            )
        }


        { showExcel && (


            <ShowTheExcel handleChange={handleTheChange}  handleField={handleField} handleUpload={handleUpload}></ShowTheExcel>


            )

        }


        { producto && (

            <>
                { theSearch && (
                    <Search  show={{status:false}} setClaveProd={setClave} setText={setTheProdText}></Search>
                )

                }

                { unidad && (
                    <SearchUnidad  show={{status:false}} setClaveProd={setClaveUnidad} setUnidad={setMyUnidad}></SearchUnidad>
                )

                }
                
                <ProductoInput claveProd={clavePod} claveUnidad={claveUnidad} prodText={prodText} myUnidad={myUnidad}
                showSearch={setTheSearch2} showUnidad={setTheUnidad} ></ProductoInput>
            </>

        )


        }

        {
            showCatalogo && (
                <FormCatalogo setClose={setShowCatalogo} ></FormCatalogo>
            )
        }

        {
            showCatConfig && (
                <>
                    <FormCatConfig close={closeCatConfig}></FormCatConfig>
                </>
            )
        }


        {
            showDoCase && (
                <>
                
                    <DoCaseParse close={closeDoCase}></DoCaseParse>
                
                </>
            )

        }


        
         


        { data.length > 0 && (

            <div>

            <p >LoadExcel</p>

            <table className='table'>
                <thead>
                    <tr>
                        { Object.keys(data[0]).map((key) => (

                            <th key={key}>{key}</th>

                        )  ) } 

                    </tr>

                </thead>
                <tbody>

                    { data.map((row,index) => (
                        <tr key={index}>

                            {  Object.values(row).map((value,index) => (

                                //<th key={index}>{value}</th>
                                <th key={index}>{  ( value instanceof Date ) ?   getFormatDate(  value  )  : value}</th>
                            )   ) } 

                        </tr>


                    ))


                    }

                </tbody>

            </table>

            </div>

        )

        }

    </div>
  )
}
